// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__vlmjm","description":"style_description__pRdby","icon":"style_icon__6iH_n","info":"style_info__TBiGk","link":"style_link__KBLzf"};